import { useState } from "react";
import { siteData } from "@/mocks/siteData";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": siteData.faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Perguntas Frequentes
          </h2>
          <p className="mt-3 text-foreground-500 text-sm">
            Tudo que você precisa saber sobre o CSSBuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {siteData.faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </span>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}